import { Answer } from "./answer";

export class AnswersWithUserId {
    userId : number;
    assignmentId : number;
    answers : Answer[];

    constructor() {
        this.userId = 0;
        this.assignmentId = 0;
        this.answers = [];
    }
}